export const COST_LIST_GET = '[COST LIST] GET';
export const COST_LIST_SUCCESS = '[COST LIST] SUCCESS';
export const COST_LIST_FAIL = '[COST LIST] FAIL';
